import { AuditEntity } from './AuditEntity';
import { FoodTray } from './FoodTrayTemplate';
import { FoodType } from './FoodType';

export enum ExitReason {
  WASTE = 'WASTE',
  EMPTY = 'EMPTY',
}

export interface FoodItem extends AuditEntity {
  foodTray: FoodTray;
  overrideFoodType: FoodType | null;
  enteredAt?: string;
  exitedAt?: string;
  exitReason?: ExitReason;
}

export enum FoodTraySlotIndex {
  TOP = 0,
  MIDDLE = 1,
  BOTTOM = 2,
}
